import { http, HttpResponse } from 'msw';

const baseUrl = `${process.env.NEXT_PUBLIC_API_BASE_URL}/incidents`;

type IncidentsRecordType = Required<{
  id: number;
  notify_admins: boolean;
  notify_signed_in_admins: boolean;
  notify_users: boolean;
  notify_signed_in_users: boolean;
  message: string;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
}>;

export const incidentsRecords: IncidentsRecordType[] = [
  {
    id: 1,
    notify_admins: false,
    notify_signed_in_admins: false,
    notify_users: true,
    notify_signed_in_users: true,
    message: '障害通知１',
    created_at: '2022-11-01T10:00:00+09:00',
    updated_at: '2022-11-01T12:00:00+09:00',
    deleted_at: null,
  },
  {
    id: 2,
    notify_admins: false,
    notify_signed_in_admins: false,
    notify_users: true,
    notify_signed_in_users: false,
    message: '改行あり\n障害通知２',
    created_at: '2022-11-02T10:00:00+09:00',
    updated_at: '2022-11-02T12:00:00+09:00',
    deleted_at: null,
  },
  {
    id: 3,
    notify_admins: false,
    notify_signed_in_admins: false,
    notify_users: false,
    notify_signed_in_users: true,
    message: '削除済み障害通知３',
    created_at: '2022-11-03T10:00:00+09:00',
    updated_at: '2022-11-03T12:00:00+09:00',
    deleted_at: '2022-11-03T14:00:00+09:00',
  },
];

export const incidentsHandlers = [
  // 全組織管理者向け障害通知一覧
  http.get(baseUrl, (_) => {
    console.group(baseUrl);

    // const filteredIncidents = incidentsRecords.filter(
    //   (incident) => incident.deleted_at === null && incident.notify_users
    // );

    const response = {
      // incidents: filteredIncidents.map((incident) => {
      //   return {
      //     id: incident.id,
      //     message: incident.message,
      //   };
      // }),
      incidents: [],
    };

    console.info(response);
    console.groupEnd();

    return HttpResponse.json(response);
  }),
];
